// Supabase client for TaskBloom (HR & Mechanical data)
import { createClient } from '@supabase/supabase-js';

const TASKBLOOM_SUPABASE_URL = import.meta.env.VITE_TASKBLOOM_SUPABASE_URL || 'https://mxtkabejdsoqkgtqjaaw.supabase.co';
const TASKBLOOM_SUPABASE_ANON_KEY = import.meta.env.VITE_TASKBLOOM_SUPABASE_ANON_KEY || 
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im14dGthYmVqZHNvcWtndHFqYWF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1MTIxMzIsImV4cCI6MjA3MTA4ODEzMn0.RXQ_l31IZwdLZngsixdalK8LRrkZJVEIPdfJFMgtKhg';

// Create separate Supabase client for TaskBloom
export const taskbloomSupabase = createClient(TASKBLOOM_SUPABASE_URL, TASKBLOOM_SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'taskbloom-supabase-auth', // Separate storage key to avoid conflicts
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
  global: {
    headers: {
      'x-application-name': 'report-vault-taskbloom',
    },
  },
  db: {
    schema: 'public',
  },
});

